module.exports = __webpack_public_path__ + "img/960x500.cc2ea0fb.png";